import { Component } from '@angular/core';
import { AuthandregistryService } from '../service/authandregistry.service';

@Component({
  selector: 'app-start',
  standalone: false,

  templateUrl: './start.component.html',
  styleUrl: './start.component.scss'
})
export class StartComponent {
  textSkipper = ['innovation', 'business', 'product']
  shownText = 'innovation'
  changeTextClass = ''

  constructor(
    private auth: AuthandregistryService
  ) {
    this.changeText();
    auth.doAutoLogin();
  }


  async changeText() {
    for (const text of this.textSkipper) {
      this.changeTextClass = '';
      await new Promise(resolve => setTimeout(resolve, 50));
      this.shownText = text;
      this.changeTextClass = 'changetext';
      await new Promise(resolve => setTimeout(resolve, 3000));
    }
    this.changeText();
  }
}
